<script>
    import clientStatusActions from './actions.vue';
    import clientStatusTable from './table.vue';
    import clientStatusFilterModal from './filter-modal.vue';
    import clientStatusColumnpresetModal from './columnpreset-modal.vue';
    import clientStatusSearch from './search.vue';
    import toaster from "../../common/toaster";
    import fixAriaTag from "../searchBarWorkaround";

    export default {
        components: {
            clientStatusActions,
            clientStatusTable,
            clientStatusFilterModal,
            clientStatusColumnpresetModal,
            clientStatusSearch,
        },
        data() {
            return {
                t_filter_load_error: Lang.langGet("Failed to load filter."),
                t_column_load_error: Lang.langGet("Failed to load Column Presets."),
                existing_filters: [],
                own_filters: [],
                existing_columns: [],
                search: '',
                groups: [],
                locations: [],
                action_visibility: false
            }
        },
        methods: {
            loadFilter: function () {
                axios.post('/system/client-status/filter', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.existing_filters = response.data.data.existing;
                    this.own_filters = response.data.data.own;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_filter_load_error);
                });
            },
            loadColumns: function () {
                axios.post('/system/client-status/column', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.existing_columns = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_column_load_error);
                });
            }
        },
        mounted() {
            this.loadFilter();
            this.loadColumns();

            EaseEventBus.listen('updateExistingFilters', () => {
                this.loadFilter();
            });

            EaseEventBus.listen('updateExistingColumnPresets', () => {
                this.loadColumns();
            });

            fixAriaTag($(this.$el));
        }
    }
</script>
